
  import {Component, Vue} from "vue-property-decorator";
  import ProfileForm from "@/modules/Profile/components/ProfileForm.vue";
  import {IProfile} from "@/modules/Profile/interfaces/profile.interface";
  import ProfilePayment from "@/modules/Profile/components/payment/ProfilePayment.vue";
  import ProfileTheme from "@/modules/Profile/components/ProfileTheme.vue";
  import AccountsTab from "@/modules/Profile/components/accounts/AccountsTab.vue";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
  import {IAppState} from "@/interfaces/app-state.interface";

  @Component({
    components: {
      ProfileForm,
      ProfilePayment,
      ProfileTheme,
      AccountsTab,
    }
  })
  export default class ProfileTabs extends Vue {
    $refs: any;
    activeTab: IProfile.PageTab = IProfile.PageTab.Form;

    get storeState(): IAppState { return this.$store.state; }
    get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
    get refMode() { return this.storeState.profile.refMode; }
    get tabs() {
      let dataTabs = [
        { label: 'Главная',   icon: 'user',        name: IProfile.PageTab.Form,    componentName: 'ProfileForm', changeTabAction: true, },
        { label: 'Оплата',    icon: 'credit-card', name: IProfile.PageTab.Payment, componentName: 'ProfilePayment', },
        { label: 'Настройки', icon: 'gear',        name: IProfile.PageTab.Theme,   componentName: 'ProfileTheme', changeTabAction: true, },
      ];
      if (this.userAccess.scUserPersons) {
        let accountsTab = { label: 'Аккаунты', icon: 'users', name: IProfile.PageTab.Accounts, componentName: 'AccountsTab', };
        dataTabs.splice(1, 0, accountsTab);
      }
      return dataTabs;
    }

    async mounted() {
      if (this.$route.hash) {
        const routeTab = this.$route.hash.replace(/^#|[&?].*$/g, "");
        if (this.tabs.map(item => item.name).includes(routeTab as IProfile.PageTab)) {
          this.activeTab = routeTab as IProfile.PageTab;
        }
      }
    }

    changeTab() {
      this.$router.replace({ hash: `#${this.activeTab}` });
    }

    leaveTabAction(newTab, oldTab) {
      let tab = this.tabs.find(item => item.name === oldTab);
      if (tab && tab.changeTabAction) this.$refs[tab.componentName][0].changeTabAction();
    }
  }
